import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Numpad extends ClickElement {
  value: string = '0';
  decimals: number = 0;

  constructor() {
    super();
    this.elementType = ElementType.numpad;
  }
}
